import { createSlice } from "@reduxjs/toolkit";
import {
  createHotelFacility,
  deleteHotelFacility,
  deleteUndoHotelFacility,
  fetchFacility,
  fetchOneFacility,
  updateHotelFacility,
} from "./facilityThunks";

const initialState = {
  data: [],
  oneFacility: null,
  totalPages: 1,
  totalItems: 0,
  loading: false,
  error: null,
};

const hotelFacilitySlice = createSlice({
  name: "hotelFacility",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel Facilities
      .addCase(fetchFacility.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // get One Amenity
      .addCase(fetchOneFacility.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOneFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.oneFacility = action.payload;
      })
      .addCase(fetchOneFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Hotel Facilities
      .addCase(createHotelFacility.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createHotelFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(createHotelFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Hotel Facilities
      .addCase(updateHotelFacility.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHotelFacility.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(updateHotelFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Hotel Facilities
      .addCase(deleteHotelFacility.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHotelFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((item) => item._id !== action.payload);
      })
      .addCase(deleteHotelFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Undo Delete Hotel Facilities
      .addCase(deleteUndoHotelFacility.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUndoHotelFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((item) => item._id !== action.payload);
      })
      .addCase(deleteUndoHotelFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default hotelFacilitySlice.reducer;
